export const isValidUserId = (
  id: string | number | null | undefined,
): boolean => id != null && /^\d+$/.test(String(id)) && Number(id) > 0;
